export const languageStringsContact = {
  title: "Kontaktní údaje",
  basic: {
    title: "Základní informace",
    accountType: "Typ účtu",
    personal: "Osobní",
    business: "Podnikatelský",
    name: "Jméno",
    surname: "Příjmení",
    phone: "Telefoní číslo",
    dic: "DIČ",
    ico: "IČO",
    companyName: "Název společnosti",
  },
  address: {
    title: "Adresa",
    street: "Ulice a č. p.",
    city: "Město",
    zip: "PSČ",
    country: "Země",
    state: "Stát",
    czechRepublic: "Česká republika",
    slovakia: "Slovensko",
    hungary: "Maďarsko",
    polish: "Polsko",
  },
};
